import React, { useState, useEffect } from "react";
import Spline from "@splinetool/react-spline";
import "./spline.css";

export default function SplineModel({ onLoaded }) {
    const [isLoading, setIsLoading] = useState(true);

    const handleLoad = (spline) => {
        setIsLoading(false);
        onLoaded && onLoaded();

        // Only set zoom level
        if (spline) {
            try {
                spline.setZoom(0.8);
            } catch (error) {
                console.log("Unable to set zoom level:", error);
            }
        }
    };

    useEffect(() => {
        const handleResize = () => {
            const canvas = document.querySelector(".spline-scene canvas");
            if (canvas) {
                const navbarHeight = parseInt(getComputedStyle(document.documentElement)
                    .getPropertyValue('--navbar-height') || '80');
                canvas.width = window.innerWidth;
                canvas.height = window.innerHeight - navbarHeight;
            }
        };

        window.addEventListener("resize", handleResize);
        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className="spline-container">
            {isLoading && <div className="loading-spinner" />}
            <Spline
                className="spline-scene"
                scene="https://prod.spline.design/SrlaD6LRx0WEbTSQ/scene.splinecode"
                onLoad={handleLoad}
            />
        </div>
    );
}
